import { EndCapProduct } from '@common/models';
import { createFetchProductsHook } from '@core/utils/createFetchProductsHook';
import { useFetchEndCapQuery } from '@ee-api/endcaps-api/endCapsService';
import { useSelectedMaterial } from '@ee-api/materials-api/useSelectedMaterial';

type UseEndCapReturn = ReturnType<typeof _useEndCap> & {
    data?: EndCapProduct[];
    EndCapItems: EndCapProduct[];
    isFetchingEndCap: boolean;
};

const emptyArray = [] satisfies EndCapProduct[];

const _useEndCap = createFetchProductsHook({
    apiQueryHook: useFetchEndCapQuery,
});

export const useEndCaps = (): UseEndCapReturn => {
    const { isLaminateSelected } = useSelectedMaterial();

    return _useEndCap({
        skip: !isLaminateSelected,
        selectFromResult: (result) => {
            return {
                EndCapItems: result.isSuccess && result.data ? result.data : emptyArray, // T
                isFetchingEndCap: result.isFetching,
                ...result,
            };
        },
    });
};
